<template>
  <div class="event-materials">
    <div v-if="isFetching" class="page-loader">
      <c-loader/>
    </div>

    <div v-else>
<!--      <div class="session-content-block__title">Materials</div>-->
      <material-list @open="openMaterialModal" :materials="materials"/>

      <!-- material modal -->
      <c-modal
        v-if="showMaterialModal"
        :title="material?.title"
        size="lg"
        @close="closeMaterialModal"
      >
        <div class="modal-body">
          <div v-if="isFetchingMaterial" class="agenda-page-loader">
            <c-loader />
          </div>

          <material-preview v-else :material="material" />
        </div>
        <div class="modal-footer">
          <c-button
            uppercase
            fill
            theme="default"
            size="sm"
            icon="fa-close"
            @click="closeMaterialModal"
          >Close</c-button>
        </div>
      </c-modal>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.event-materials {
  background-color: white;
  border-radius: var(--attendee-card-border-radius);
  padding: var(--attendee-gap-md);
}



</style>

<script>
import MaterialPreview from "../agenda/event-agenda/event-agenda-detail/material-preview";
import PageTitle from "../../components/ui/PageTitle";
import common from "../../helpers/common";

import eventMaterialAPI from "../../api/eventMaterialAPI";
import MaterialList from "../../components/common/material-list";

export default {
  components: {
    MaterialList,
    MaterialPreview,
    PageTitle,
  },
  mounted() {
    common.setHeaderText('Materials');

    this.fetchMaterials()

  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      materials: [],
      material: {
        embed_code: '',
        url: '',
        allow_download: '',
        uuid_url: '',
        original_filename: '',
        name: '',
      },
      isFetching: false,
      isFetchingMaterial: false,
      showMaterialModal: false,
    }
  },
  computed: {},
  methods: {
    openMaterialModal(materialId) {
      this.showMaterialModal = true;

      this.fetchMaterial(materialId);
    },
    closeMaterialModal() {
      this.material = {
        embed_code: '',
        url: '',
        allow_download: '',
        uuid_url: '',
        original_filename: '',
        name: '',
      };
      this.showMaterialModal = false;
    },

    fetchMaterial(materialId) {
      this.isFetchingMaterial = true;

      eventMaterialAPI.fetchMaterial(this.attendeeId, materialId)
        .then((res) => {
          this.material = res.data.data;
        })
        .catch(() => {
        })
        .finally(() => {
          this.isFetchingMaterial = false;
        });
    },

    fetchMaterials() {
      this.isFetching = true;

      eventMaterialAPI.fetchMaterials(this.attendeeId)
        .then((res) => {
          this.materials = res.data.data;
        })
        .catch(() => {
        })
        .finally(() => {
          this.isFetching = false;
        });
    },
  }
}
</script>